// Tabs
export const TABS_ID = 'slotTemplatesEdit';

export const SLOT_DAY_PREFIX = 'slotEditDay0';

export enum SlotTemplateEditTabs {
  edit = 'edit-slots',
  schedule = 'schedule',
  details = 'template-details',
}

export enum FulfillmentTypes {
  Delivery = 'Delivery',
  Pickup = 'Pickup',
  Instacart = 'Instacart',
}

export const FORM_EDIT_CALENDAR = 'calendarSlotManagement';

// Create New Slot (Modal)
export const TABS_SLOTEDIT_ID = 'slotTemplatesModalEdit';
export const TAB_SLOTEDIT_DETAILS = 'slotTemplatesModalEditDetails';
export const TAB_SLOTEDIT_AREAS = 'slotTemplatesModalEditAreas';
export const FORM_SLOTEDIT_TIME_INI = 'slotEditTimeIni';
export const FORM_SLOTEDIT_TIME_END = 'slotEditTimeEnd';
export const FORM_SLOTEDIT_TIME_INI_DEFAULT = '00:00';
export const FORM_SLOTEDIT_TIME_END_DEFAULT = '02:00';

export const FORM_SLOTEDIT_DAY_ALL = 'slotEditDayAll';
export const FORM_SLOTEDIT_DAY_01 = `${SLOT_DAY_PREFIX}1`;
export const FORM_SLOTEDIT_DAY_02 = `${SLOT_DAY_PREFIX}2`;
export const FORM_SLOTEDIT_DAY_03 = `${SLOT_DAY_PREFIX}3`;
export const FORM_SLOTEDIT_DAY_04 = `${SLOT_DAY_PREFIX}4`;
export const FORM_SLOTEDIT_DAY_05 = `${SLOT_DAY_PREFIX}5`;
export const FORM_SLOTEDIT_DAY_06 = `${SLOT_DAY_PREFIX}6`;
export const FORM_SLOTEDIT_DAY_00 = `${SLOT_DAY_PREFIX}0`;

export const FORM_SLOTEDIT_CAPACITY = 'slotEditCapacity';
export const FORM_SLOTEDIT_CUTOFF_HOURS = 'slotEditCutOffHours';
export const FORM_SLOTEDIT_CUTOFF_MINUTES = 'slotEditCutOffMinutes';
export const FORM_SLOTEDIT_AMEND_TOGGLE = 'slotToggleAmend';
export const FORM_SLOTEDIT_AMEND_CUTOFF_HOURS = 'slotEditAmendCutOffHours';
export const FORM_SLOTEDIT_AMEND_CUTOFF_MINUTES = 'slotEditAmendCutOffMinutes';
export const FORM_SLOTEDIT_PICKING_STARTING_TOGGLE = 'slotEditTogglePickingStart';
export const FORM_SLOTEDIT_PICKING_STARTING_HOURS = 'pickingStartTimeHours';
export const FORM_SLOTEDIT_PICKING_STARTING_MINUTES = 'pickingStartTimeMinutes';
export const FORM_SLOTEDIT_PICK_BY_HOURS = 'slotEditPickByHours';
export const FORM_SLOTEDIT_PICK_BY_MINUTES = 'slotEditPickByMinutes';
export const FORM_SLOTEDIT_USE_DEFAULT_PICK_BY = 'slotEditDefaultPickBy';
export const FORM_SLOTEDIT_PRICE = 'slotEditPrice';
export const FORM_SLOTEDIT_SAME_DAY_PRICE = 'slotEditSameDayPrice';
export const FORM_SLOTEDIT_FULFILLMENT = 'slotEditFulfillment';
export const FORM_SLOTEDIT_TAGS = 'slotEditTags';
export const FORM_SLOTEDIT_SHOPPINGID = 'shoppingModeId';
export const FORM_SLOTEDIT_SERVICEID = 'supportedServiceType';

// Stores & Schedule
export const FORM_STORES = 'templateStores';
export const FORM_SCHEDULE = 'templateSchedule';
export const STORES_AND_SCHEDULE_MODAL = 'STORES_AND_SCHEDULE_MODAL';

// Details
export const FORM_DETAILS_ID = 'templateEditId';
export const FORM_DETAILS_NAME = 'templateEditName';
export const FORM_DETAILS_SHOPPINGMODE = 'templateEditShoppingMode';
export const FORM_DETAILS_AVAILABLE_STORES = 'templateEditAvailableSTores';
